import { colors } from "config/styles/themeColors";
import { fontSize } from "config/styles/fonts";

const styles = {
  breadcrumbs: {
    maxWidth: {
      xs: "300px",
      md: "100%",
    },
  },
  breadcrumbLink: {
    fontSize: {
      md: fontSize.s,
    },
    color: colors.gray.main,
    textDecoration: "none",
  },
  breadcrumbActive: {
    fontSize: {
      md: fontSize.s,
    },
    color: colors.gray.main,
    fontWeight: 900,
  },
};

export default styles;
